"use client"
import React, { useState, useEffect } from "react";
import { useAppData } from "@/lib/providers/AppDataProvider";
import AmenityIcon from "@/components/categories/AmenityIcon";
import ScrollBox from "@/components/shared/ScrollBox";

import "@/components/categories/AmenityFilter.css";

const AmenityFilter = ({
  values,
  multiple,
  onSelect,
  scrollable,
  iconSize,
  stacked,
  showOpenNow,
  onOpenNow,
  vertical = false
}) => {
  const [openNow, setOpenNow] = useState(true);
  const [selected, setSelected] = useState([]);
  const { amenities } = useAppData();

  useEffect(() => {
    if (onOpenNow) {
      onOpenNow(openNow);
    }
  }, [openNow]);

  const openNowAmenity = {
    label: "Open Now",
    icon: "fa-clock"
  };

  const toggleAmenity = value => {
    if (multiple) {
      var newSelected = [...selected];
      var index = newSelected.findIndex(s => s === value);
      if (index > -1) {
        newSelected.splice(index, 1);
      } else {
        newSelected.push(value);
      }
      setSelected(newSelected);
      onSelect(newSelected.length > 0 ? newSelected : null);
    } else {
      if (selected.includes(value)) {
        setSelected([]);
        onSelect(null);
      } else {
        setSelected([value]);
        onSelect([value]);
      }
    }
  };

  const elements = () => {
    var icons = showOpenNow
      ? [
          <div
            style={{ cursor: "pointer" }}
            onClick={() => setOpenNow(!openNow)}
          >
            <AmenityIcon
              key="amenity-open-now"
              className={openNow ? "selected" : null}
              amenity={openNowAmenity}
              size={iconSize}
              stacked={stacked}
            />
          </div>
        ]
      : [];
    var allIcons = icons.concat(
      values.map((val, index) => {
        return (
          <div key={`amenity-icon-wrapper-${index}`} style={{ cursor: "pointer" }} onClick={() => toggleAmenity(val)}>
            <AmenityIcon
              key={`amenity-${index}`}
              className={selected.includes(val) ? "selected" : null}
              amenity={amenities.find(am => am.value === val)}
              size={iconSize}
              stacked={stacked}
            />
          </div>
        );
      })
    );
    return allIcons;
  };

  if (values && amenities) {
    return (
      <div className={`amenity-filter${vertical ? " vertical" : ""}`}>
        {scrollable ? <ScrollBox>{elements()}</ScrollBox> : <>{elements()}</>}
      </div>
    );
  } else {
    return <></>;
  }
};
export default AmenityFilter;
